<div class="border-bottom container-fluid mw-100">
  @if (releaseSummary(); as summary) {
    <div class="row px-2 py-2 gx-4 align-items-center main-row">
      <div class="col-auto d-none d-md-flex align-items-center" [style.width.px]="selectionWidth">
        @if (selectable()) {
          <app-selection-checkbox
            [ngModel]="selected() ? checkboxSelectionState.selected : checkboxSelectionState.unselected"
            (ngModelChange)="selectionToggled.emit()"></app-selection-checkbox>
        }
      </div>
      <div class="col col-xl-2 col-xxl-2 d-flex flex-column justify-content-center flex-grow-1 flex-md-grow-0 container-number-section">
        <div class="d-flex align-items-stretch">
          <span class="text-info d-inline-block text-truncate mw-100 cursor-pointer h2 text-info hover-underline mb-0"
                (click)="openDetails()" [title]="summary.releaseData?.equipmentNumber">
            <app-highlight [term]="term()" [result]="summary.releaseData?.equipmentNumber" emptyText="New declaration"></app-highlight>
          </span>
          @if (summary.releaseStatus?.cancelled) {
            <app-tooltip placement="top" class="ms-2">
              <span class="fa text-danger fa-fw fa-ban"></span>
              <span class="tooltipContent">Cancelled</span>
            </app-tooltip>
          }
        </div>
      </div>
      <div class="col-auto d-none d-vlg-flex flex-column justify-content-center text-truncate dropdown crn-section-cr" [style.width.px]="210">
        @if (summary.crn) {
          <button class="btn btn-plain p-0 d-inline-block text-truncate mw-100 link-primary text-body text-start"
                  [title]="summary.crn" data-bs-toggle="dropdown">
            <span class="fa fa-fw fa-light fa-ship sub-text me-1" [style.line-height.rem]="1.25"></span>
            <app-highlight [term]="term()" [result]="summary.crn"></app-highlight>
            <span class="ms-1 m-0 text-primary">
              <i class="fa-light fa-fw fa-chevron-down"></i>
            </span>
          </button>
          <ul class="dropdown-menu position-fixed">
            <a class="dropdown-item" [routerLink]="'/details/' + summary.crn" target="_blank">
              <i class="fa-light fa-fw fa-arrow-up-right-from-square"></i>
              Open visit
            </a>
            <a class="dropdown-item" [routerLink]="'/commercial-release-new/' + summary.crn">
              <i class="fa-light fa-fw fa-filter"></i>
              Filter overview by this CRN
            </a>
          </ul>
        }
        <div class="d-flex align-items-center">
          <span class="fa fa-fw fa-light fa-file-lines sub-text me-1" [style.line-height.rem]="1.25" [style.width.px]="20"></span>
          <app-highlight [term]="term()" [result]="summary.releaseData?.consignmentNumber"></app-highlight>
        </div>
      </div>
      <div class="col d-none d-lg-flex flex-column justify-content-center flex-shrink-0 party-section" [style.width.px]="170">
        <div class="d-flex align-items-center text-truncate" title="Release-to party">
          @if (summary.releaseData?.releaseToParty) {
            <span class="fa-light fa-fw me-1" [ngClass]="releaseToPartyIconClass()" [style.width.px]="17.5"></span>
          }
          <span class="text-truncate">{{ summary.releaseData?.releaseToParty?.name }}</span>
        </div>
        @if (summary.releaseData?.containerOperator?.cargoDeclarantShortName &&
        appContext.userProfile.organisation?.shortName !== summary.releaseData?.containerOperator?.cargoDeclarantShortName) {
          <div class="d-flex align-items-center text-truncate" title="Container operator">
            <span class="fa-light fa-fw fa-user-headset me-1"></span>
            <span class="text-truncate">{{ summary.releaseData?.containerOperator?.name }}</span>
          </div>
        }
      </div>
      @if (!appContext.isHinterlandTerminal()) {
        <div class="col-auto d-none d-lg-flex flex-column justify-content-center flex-shrink-0 terminal-deadline-section" [style.width.px]="250">
          <div class="d-flex align-items-center text-truncate" title="Terminal">
            @if (summary.releaseData?.terminalShortName) {
              <span class="fa fa-fw fa-kit fa-light fa-pb-cargo-crane me-1"></span>
            }
            <span class="text-truncate">{{ terminalOrganisationName(summary.releaseData?.terminalShortName) }}</span>
          </div>
          <div class="d-flex align-items-center text-truncate" title="Release deadline">
            <span class="fa-light fa-fw fa-clock-nine me-1" [style.width.px]="20"></span>
            <span class="text-truncate">{{ (summary.releaseData?.releaseDeadline | date:'dd MMM HH:mm') || 'No date' }}</span>
          </div>
        </div>
      }
      <div class="col-auto ms-auto d-flex align-items-start">
        <div class="col-auto d-flex flex-column align-items-start justify-content-start status-column" [style.width.px]="150">
          <app-status-indicator [messageStatuses]="releaseMessageStatus()" summarySize="lg">
            <span>{{ releaseTaskStatus() | sentenceCase }}</span>
          </app-status-indicator>
        </div>
        <div class="col-auto d-flex flex-row align-items-center justify-content-center dropdown" [style.height.px]="48">
          <!-- Phase 2 will wire the real detail/declare modal here; placeholder for now. -->
          <a class="btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg" type="button" (click)="openDetails()">
            <i class="fa-light fa-chevron-right"></i>
          </a>
          <button class="d-none d-md-block btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg" type="button"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa-light fa-ellipsis-vertical"></i>
          </button>
          <div class="dropdown-menu position-fixed">
            @if (summary.crn) {
              <a class="dropdown-item" [routerLink]="'/details/' + summary.crn" target="_blank">
                <i class="fa-light fa-fw fa-arrow-up-right-from-square"></i>
                Open visit
              </a>
              <a class="dropdown-item" [routerLink]="'/commercial-release-new/' + summary.crn">
                <i class="fa-light fa-fw fa-filter"></i>
                Filter overview by this CRN
              </a>
            }
            @if (appContext.isAdmin()) {
              <div class="dropdown-divider"></div>
              @if (!!summary.releaseStatus.status) {
                <button class="dropdown-item" type="button"
                        (click)="utils.fetchProcessIdAndOpenMessageManagement('coreor-in-' + summary.id)">
                  Commercial release from carrier
                </button>
                <button class="dropdown-item" type="button"
                        (click)="utils.fetchCoreorOutProcessIdAndOpenMessageManagement(summary.id)">
                  Commercial release to terminal
                </button>
              }
              @if (adminAllowedToManipulateCR()) {
                <app-confirmation-toggle>
                  <span class="dropdown-item cursor-pointer">Resubmit</span>
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Resubmit release</h5>
                    </div>
                    <div class="modal-body">
                      <p>Are you sure that you want to resubmit this release as admin?</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                    </div>
                  </div>
                </app-confirmation-toggle>
                <app-confirmation-toggle>
                  <span class="dropdown-item cursor-pointer">Accept</span>
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Accept release</h5>
                    </div>
                    <div class="modal-body">
                      <p>Are you sure that you want to accept this release as admin?</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                      <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="acceptRelease()">Yes
                      </button>
                    </div>
                  </div>
                </app-confirmation-toggle>
                <app-confirmation-toggle>
                  <span class="dropdown-item cursor-pointer">Reject</span>
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Reject release</h5>
                    </div>
                    <div class="modal-body">
                      <input class="form-control" required placeholder="Enter reasons" [(ngModel)]="rejectionReasons">
                      <p>Are you sure that you want to reject this release as admin?</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                      <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="rejectRelease()">Yes
                      </button>
                    </div>
                  </div>
                </app-confirmation-toggle>
              }
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
